<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="flex items-center mb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Dokumen Pra-Presentasi PJP Baru
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="row">
              <div
                class="col-md-6 d-flex justify-content-start"
                style="padding-left: 2rem; padding-top: 0.5rem"
              >
                <img
                  src="../../../assets/images/borneo-indobara-icon.png"
                  alt=""
                  style="width: 15%; height: auto"
                />
              </div>
              <div
                class="col-md-6 d-flex justify-content-end"
                style="padding-right: 2rem; padding-top: 0.5rem"
              >
                <p class="fs-5 fw-bold" style="">BIB-HSE-PPO-F-096-04</p>
              </div>
            </div>
            <div class="container p-4">
              <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                SURAT PERNYATAAN CALON PJO
              </h1>
              <p
                class="text-center fs-8 mb-3"
                style="font-family: 'Inter-Regular'"
              >
                Formulir ini untuk menyatakan komitmen calon Penanggung Jawab
                Operasional
              </p>
              <!-- form di sini -->
              <form action="#">
                <!-- <div class="row mb-1">
                        <div class="col-md-12">
                            <p class="text-danger fst-italic fs-8 fw-bold">
                                * Wajib diisi
                            </p>
                        </div>
                    </div> -->
                <div class="row mb-2">
                  <div class="col-md-3">&nbsp;</div>
                  <div class="col-md-6">
                    <p for="nomor" class="form-label text-center fs-8 fw-bold">
                      Nomor
                    </p>
                    <p class="form-label text-center fs-8">
                      {{ formValues.nomor }}
                    </p>
                  </div>
                  <div class="col-md-3">&nbsp;</div>
                </div>
                <p class="mb-2 fs-8">Saya yang bertanda tangan di bawah ini:</p>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Nama</label
                    >
                    <p class="form-label fs-8">{{ formValues.nama }}</p>
                  </div>
                  <div class="col-md-6">
                    <label for="jabatan" class="form-label fs-8 fw-bold"
                      >Jabatan</label
                    >
                    <p class="form-label fs-8">{{ formValues.jabatan }}</p>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="perusahaan" class="form-label fs-8 fw-bold"
                      >Perusahaan</label
                    >
                    <p class="form-label fs-8">
                      {{ kontraktor.namaKontraktor }}
                    </p>
                  </div>
                </div>
                <p class="mb-1 fs-8" style="font-family: 'Inter-Regular'">
                  Bahwa sesuai:
                </p>
                <ol type="1" class="fs-8" style="font-family: 'Inter-Regular'">
                  <li>
                    Undang Undang No. 32 Tahun 2009 mengenai Perlindungan dan
                    Pengelolaan Lingkungan Hidup
                  </li>
                  <li>
                    Peraturan Menteri ESDM Nomor 26 Tahun 2018 tentang
                    Pelaksanaan Kaidah Pertambangan yang Baik dan Pengawasan
                    Pertambangan Mineral dan Batubara
                  </li>
                  <li>
                    Keputusan Menteri ESDM Nomor 1827 K/30/MEM/2018 tentang
                    Pedoman Pelaksanaan Kaidah Teknik Pertambangan yang Baik
                  </li>
                  <li>
                    KepDirjen Minerba No. 185.K/37.04/DJB/2019 tentang Petunjuk
                    Teknis Pelaksanaan Pertambangan dan Pelaksanaan, Penilaian,
                    dan Pelaporan Sistem Manajemen Keselamatan Pertambangan
                    Minerba
                  </li>
                </ol>
                <p class="mb-1 fs-8" style="font-family: 'Inter-Regular'">
                  Menyatakan akan mematahui peraturan di atas sesuai tugas dan
                  tanggung jawab saya sebagai PJO, yaitu:
                </p>
                <ol type="1" class="fs-8" style="font-family: 'Inter-Regular'">
                  <li>
                    Membuat peraturan internal perusahaan mengenai penerapan
                    kaidah teknik pertambangan yang baik mengacu kepada
                    peraturan perusahaan pemegang IUP;
                  </li>
                  <li>
                    Implementasi Sistem Manajemen Keselamatan Pertambangan
                    (SMKP);
                  </li>
                  <li>
                    Memastikan semua perusahaan jasa pertambangan yang
                    beroperasi di bawahnya memenuhi kewajiban sesuai dengan
                    ketentuan perundang-undangan;
                  </li>
                  <li>
                    Menerapkan standar sesuai dengan ketentuan
                    perundang-undangan;
                  </li>
                  <li>
                    Menyampaikan laporan kegiatan jasa pertambangan kepada KTT
                    sesuai dengan ketentuan perundang-undangan;
                  </li>
                  <li>
                    Memiliki tenaga teknis pertambangan yang berkompeten sesuai
                    dengan ketentuan perundang-undangan;
                  </li>
                  <li>
                    Melaksanakan manajemen risiko pada setiap proses bisnis dan
                    subproses kegiatan pertambangan;
                  </li>
                  <li>
                    Menerapkan sistem manajemen keselamatan pertambangan dan
                    melakukan pengawasan penerapan sistem manajemen keselamatan
                    pertambangan yang dilaksanakan oleh perusahaan jasa
                    pertambangan yang bekerja di wilayah tanggung jawabnya;
                  </li>
                  <li>
                    Melaporkan penerapan kaidah teknik pertambangan yang baik
                    kepada KTT, baik laporan berkala, akhir, dan/atau khusus
                    sesuai dengan ketentuan perundang-undangan;
                  </li>
                  <li>
                    Melaporkan pelaksanaan kegiatan pengelolaan dan pemantauan
                    lingkungan secara berkala sesuai dengan bentuk yang
                    ditetapkan;
                  </li>
                  <li>
                    Melaporkan jumlah pengadaan, penggunaan, penyimpanan, dan
                    persediaan bahan dan limbah berbahaya dan beracun secara
                    berkala setiap 6 (enam) bulan atau kurang dari itu apabila
                    diperlukan sesuai kebijakan Perusahaan.
                  </li>
                  <li>
                    Melaporkan adanya gejala yang berpotensi menimbulkan
                    pencemaran dan/atau perusakan lingkungan;
                  </li>
                  <li>
                    Menyampaikan laporan kasus lingkungan paling lambat 1 x 24
                    (satu kali dua puluh empat) jam setelah terjadinya kasus
                    lingkungan berikut upaya penanggulangannya;
                  </li>
                  <li>
                    Menyampaikan pemberitahuan awal dan melaporkan kecelakaan,
                    kejadian berbahaya, kejadian akibat penyakit tenaga kerja,
                    dan penyakit akibat kerja;
                  </li>
                  <li>
                    Menyampaikan laporan audit internal penerapan Sistem
                    Manajemen Keselamatan Pertambangan mineral dan batubara;
                  </li>
                  <li>
                    Melakukan penanggulangan pencemaran dan/atau perusakan
                    lingkungan pada tempat yang berpotensi menimbulkan perusakan
                    dan pencemaran lingkungan;
                  </li>
                  <li>Bertempat tinggal di lokasi kerja.</li>
                  <li>
                    Menghadiri rapat-rapat dan kegiatan Komite Keselamatan
                    Pertambangan dan Lingkungan Hidup PT Borneo Indobara.
                  </li>
                </ol>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Demikian Surat Pernyataan ini dibuat untuk dipergunakan
                  sebagaimana mestinya.
                </p>
                <div class="row mb-3">
                  <div class="col-md-3">
                    <label for="tempat" class="form-label fs-8 fw-bold"
                      >Tempat</label
                    >
                    <p class="form-label fs-8">{{ formValues.tempat }}</p>
                  </div>
                  <div class="col-md-3">
                    <label for="tanggal" class="form-label fs-8 fw-bold"
                      >Tanggal</label
                    >

                    <p class="form-label fs-8">{{ formValues.tanggal }}</p>
                  </div>
                </div>

                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Yang Membuat Pernyataan,
                </p>

                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="tandaTangan" class="form-label fs-8 fw-bold">
                      Tanda Tangan (png, jpg, jpeg)
                    </label>
                    <div v-if="fileTtd != '' || fileTtd != null" class="fs-8">
                      <img :src="fileTtd" style="height: 5rem" />
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="namaPimpinan" class="form-label fs-8 fw-bold"
                      >Nama Lengkap</label
                    >
                    <p class="form-label fs-8">{{ formValues.namaTTD }}</p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <label for="fileAttachment" class="form-label fs-8 fw-bold"
                      >File Dokumen (.pdf)</label
                    >
                    <div
                      v-if="fileAttachment != null || fileAttachment !== ''"
                      class="fs-8 fw-bolder"
                    >
                      <a
                        class="text-danger pointer"
                        @click="downloadFile(fileAttachment)"
                        >Surat Pernyatan Calon PJO.pdf</a
                      >
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>

  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <div>
      <img
        src="../../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
  <!-- modal filter -->
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  ></div>
</template>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../../GlobalDataMixin";
// import Datepicker from "vuejs3-datepicker"
import axios from "axios";
import {
  API_BASE_URL,
  CMS_DOWNLOAD,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_SIO_GET_PERNYATAANPJO,
  CMS_VIEW_IMAGE,
  CMS_GET_KELENGKAPAN_SIO,
} from "@/constants";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
//import Swal from "sweetalert2"

const url_get_pernyataanpjo = API_BASE_URL + CMS_SIO_GET_PERNYATAANPJO;
const url_download = API_BASE_URL + CMS_DOWNLOAD;
const url_get_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;

export default {
  mixins: [GlobalDataMixin],
  name: "Form3View",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
  },
  data() {
    return {
      isLoading: true,
      id: null,
      sioID: null,
      formValues: {
        nama: "",
        perusahaan: "",
        jabatan: "",
        kompetensi: "",
        noSertifikat: "",
        pjo: "",
        tempat: "",
        tanggal: moment(new Date()).format("YYYY-MM-DD"),
        tandaTangan: "",
        namaTTD: "",
      },
      kontraktor: [],
      kontraktorid: null,
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getPernyataanPJO(this.id);
    this.kontraktorid = this.$route.params.kontraktorid;
    this.getKontraktor(this.kontraktorid);
  },
  methods: {
    getPernyataanPJO(idform) {
      axios
        .get(url_get_pernyataanpjo + idform, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("getPernyataanPJO", response);
          let dt = response.data.data;

          if (dt != null) {
            this.sioID = dt.idSio;
            this.formValues.nomor = dt.nomorKontraktor;
            // this.formValues.nama = dt.namaCalon;
            // this.formValues.jabatan = dt.jabatan;
            this.formValues.tanggal =
              dt.tanggalTtd != null
                ? moment(dt.tanggalTtd).format("YYYY-MM-DD")
                : null;
            this.formValues.tempat = dt.tempat;
            // this.formValues.namaTTD = dt.namaPengesah;

            // if(dt.tandaTangan!=''&&dt.tandaTangan!=null){
            //   this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + dt.tandaTangan;
            // }
            if (dt.attachmentFile != "" && dt.attachmentFile != null) {
              this.fileAttachment = dt.attachmentFile;
            }
            this.$nextTick(function () {
              this.getKelengkapan(this.sioID);
            });
          }
          //this.getKontraktor(dt.kontraktorId)
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getPernyataanPJO : " + error.message);
          console.error(
            "Error fetching data getPernyataanPJO :",
            error.message
          );
        });
    },
    downloadFile(filename) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename) {
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log("blob nya = ", blob);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename; // Set the desired file name
      link.click();
    },
    getKontraktor(id) {
      axios
        .get(url_get_kontraktor + id, {
          headers: { accept: "application/json" },
        })
        .then((response) => {
          console.log(response);
          this.kontraktor = response.data.detailKontraktor;
          // set value form edit
          // this.url_icon = API_BASE_URL+CMS_VIEW_IMAGE+response.data.detailKontraktor.image;
          if (
            response.data.detailKontraktor.image != null ||
            response.data.detailKontraktor.image != ""
          ) {
            localStorage.setItem(
              "icon_kontraktor_cms",
              JSON.stringify({ icon: response.data.detailKontraktor.image })
            );
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data Detail Kontraktor : " + error.message);
          console.error("Error fetching data:", error.message);
        });
    },
    getKelengkapan(sio_id) {
      axios
        .get(url_get_kelengkapan + sio_id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);

          let ret_kel = response.data;
          this.idKelengkapan = ret_kel.id == null ? "" : ret_kel.id;
          if (this.formValues.nama == null || this.formValues.nama == "") {
            this.formValues.nama =
              ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;
          }
          if (
            this.formValues.jabatan == null ||
            this.formValues.jabatan == ""
          ) {
            this.formValues.jabatan =
              ret_kel.jabatanPjo == null ? "" : ret_kel.jabatanPjo;
          }
          if (
            this.formValues.namaTTD == null ||
            this.formValues.namaTTD == ""
          ) {
            this.formValues.namaTTD =
              ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;
          }

          this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdPjo;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
  },
};
</script>

<style scoped>
section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

.btn_eform {
  background-color: #fff;
  border: #d0d5dd;
}
</style>
